
import { useState } from "react";
import Header from "@/components/Header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CreateDaoForm } from "@/components/dao-it/CreateDaoForm";
import { ManageDaoForm } from "@/components/dao-it/ManageDaoForm";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { InfoIcon } from "lucide-react";

const DaoIt = () => {
  const [activeTab, setActiveTab] = useState("create");

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">Just DAO It</h1>
          <p className="text-muted-foreground mb-6">
            Create and manage decentralized autonomous organizations with a few simple steps
          </p>
          
          <Alert className="mb-8">
            <InfoIcon className="h-4 w-4" />
            <AlertTitle>No-code DAO Creation</AlertTitle>
            <AlertDescription>
              Deploy a complete DAO ecosystem with tokens, governance, and treasury management on multiple chains.
              This implementation is based on the <a href="https://github.com/markcarey/daoit" target="_blank" className="text-primary underline">Just DAOit</a> project.
            </AlertDescription>
          </Alert>
          
          <Tabs defaultValue="create" className="w-full" onValueChange={setActiveTab} value={activeTab}>
            <TabsList className="grid w-full grid-cols-2 mb-8">
              <TabsTrigger value="create">Create DAO</TabsTrigger>
              <TabsTrigger value="manage">Manage DAO</TabsTrigger>
            </TabsList>
            
            <TabsContent value="create" className="mt-0">
              <CreateDaoForm />
            </TabsContent>
            
            <TabsContent value="manage" className="mt-0">
              <ManageDaoForm />
            </TabsContent>
          </Tabs>
        </div>
      </main>
    </div>
  );
};

export default DaoIt;
